import React from 'react';
import { formatMoney } from '../ShoppingCartUtils/Helpers';
import PaypalBanner from '../PaypalBanner/PaypalBanner';

const ShoppingCartCta = (props) => {

    return (
        <div className="col-md-4 cart-cta-area">
            {props.hasCartItems ?
            <React.Fragment>
            {props.subtotal ?
                <div className="total-summary" tabIndex="0" aria-label={ "The shopping cart subtotal is " + `$${formatMoney(props.subtotal, 2, '.', ',')}`}>
                    <span aria-hidden="true">Subtotal:</span>
                    <span aria-hidden="true" className="listing-total">{ (props.isUpdating ? 'Calculating...' :
                        `$${formatMoney(props.subtotal, 2, '.', ',')}`) }
                    </span>
                </div>
                : ''}
            {props.discount_code ?
                <div className="total-summary" tabIndex="0" aria-label={" The discount code savings is " + `$${formatMoney(props.discount_code.value, 2, '.', ',')}` + " a " + props.discount_code.percent + "% savings." }>
                    <span aria-hidden="true">Discount Code:</span>
                    <span className="listing-total" aria-hidden="true">{ (props.isUpdating ? 'Calculating...' :
                        `-$${formatMoney(props.discount_code.value, 2, '.', ',')} (${props.discount_code.percent}%)`) }
                </span>
                </div>
                : ''}
            {props.volume_discount ?
                <div className="total-summary" tabIndex="0" aria-label={" The volume discount is " + `$${formatMoney(props.volume_discount.value, 2, '.', ',')}` + " a " + props.volume_discount.percent + "% savings." }>
                    <span aria-hidden="true">Volume Discount:</span>
                    <span className="listing-total" aria-hidden="true">{ (props.isUpdating ? 'Calculating...' :
                        `-$${formatMoney(props.volume_discount.value, 2, '.', ',')} (${props.volume_discount.percent}%)`) }
                    </span>
                </div>
            : ''}

            <div className="total-summary" tabIndex="0" aria-label={ "The shopping cart total is " + `$${formatMoney(props.total, 2, '.', ',')}`}>
                <span aria-hidden="true">Total:</span>
                <span className="listing-total" aria-hidden="true">{ (props.isUpdating ? 'Calculating...' : `$${formatMoney(props.total, 2, '.', ',')}`) }</span>
            </div>

             {!props.discount_code ?
            <div className="cart-discount-code__block--hcoded ubuntu" tabIndex="0"><i className="cart-discount-code__icon fas fa-exclamation-triangle" aria-hidden="true"></i><span>Use discount code <span className="cart-discount-code__code text-bold drk-blue">{ props.discount_code_text }</span> below.</span></div>
            : ''
             }
            <fieldset>
                <form onSubmit={props.apply_discount}>
                    <div className="input-group mb-3">
                        <input type="text" className="form-control discount-field" placeholder="Apply discount code..." aria-label="Apply discount code" aria-describedby="basic-addon2" />
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="submit" disabled={props.disableBtn}>Apply</button>
                        </div>
                    </div>
                </form>
            </fieldset>
            {/* There has been an attempt to apply a discount code, and the discount code is valid */}
            {props.discount_code ?
                <div className="discount-code-msg" tabIndex="0">
                    <span className="discount-code">{props.discount_code.code}</span>&nbsp;<span>discount code is applied</span>
                </div>
                : ''
            }
            {/* there has been an attemp to apply a discount code, but it wasnt valid */}
            {(!props.discount_code && props.discount_code_attempt && !props.discount_not_applicable) ?
                <div className="discount-code-msg" tabIndex="0">
                    <span className="discount-code">Discount code not valid</span>
                </div>
                : ''
            }
            {(props.discount_not_applicable) ?
                <div className="discount-code-msg" tabIndex="0">
                    <span className="discount-code">{props.discount_not_applicable_message}</span>
                </div>
                : ''
            }
            <div className="cart-discount-code__block--hcoded ubuntu" tabIndex="0">Sales Tax May Apply</div>
            <div className="cart-buttons">
                <form method="POST" action={ props.checkout_url }  target="_blank" >
                    <input type="hidden" name="cart_data" value={props.cart_data} />
                    <button
                        type="submit"
                        className="btn checkout-btn"
                        disabled={props.disableBtn}
                    >
                        Checkout
                    </button>
                </form>
                <a href="/" className="btn continue-shop-btn"><span>Continue</span> <span>Shopping</span></a>
            </div>
            </React.Fragment>
            : '' }

            {!props.hasCartItems ?
            <div className="cart-buttons">
                <a href="/" className="btn continue-shop-btn"><span>Continue</span> <span>Shopping</span></a>
            </div>
            : '' }

            <div className="paypal-banner__block">
                <PaypalBanner></PaypalBanner>
            </div>
        </div>
    );
};

export default ShoppingCartCta;
